import { Building2, MapPin, Check } from 'lucide-react';
import type { Property } from '@/types/web/property';

interface PropertyTileProps {
  property: Property;
  isSelected?: boolean;
  onClick: (property: Property) => void;
}

export function PropertyTile({
  property,
  isSelected = false,
  onClick,
}: PropertyTileProps) {
  return (
    <div
      onClick={() => onClick(property)}
      className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-50 border-b last:border-b-0"
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="relative">
          <Building2 className="h-4 w-4 text-gray-400" />
          {isSelected && (
            <div className="absolute -top-1 -right-1 bg-blue-600 rounded-full p-0.5">
              <Check className="h-2.5 w-2.5 text-white" />
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          {/* Property Name */}
          <div
            className={`font-medium truncate ${
              isSelected ? 'text-blue-700' : 'text-gray-900'
            }`}
          >
            {property.name}
          </div>

          {/* Property Address */}
          <div className="text-xs text-gray-500 flex items-center gap-1 mt-0.5">
            <MapPin className="h-3 w-3" />
            <span className="truncate">{property.address}</span>
          </div>

          {/* Property State */}
          {property.state && (
            <div className="text-xs text-gray-500 mt-0.5">
              <span className="font-medium">State: </span>
              {property.state}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
